export const faqData = [
  {
    question:
      "How do you approach product and service collaboration with clients?",
    answer:
      "We work as your strategic partner, not just a service provider. From the first conversation to final delivery, we focus on co-creating digital solutions that meet your business goals. Every step involves open communication, iterative feedback, and full transparency.",
  },
  {
    question: "Do you offer end-to-end product development?",
    answer:
      "Yes, we handle everything from discovery and design to development and deployment. Whether it’s a fresh build or a reimagined experience, our team takes care of the entire product lifecycle—ensuring quality, speed, and innovation throughout.",
  },
  {
    question: "What kind of businesses do you work with?",
    answer:
      "We proudly work with small, medium, and large businesses across Australia. Our approach scales with your needs—whether you’re a startup needing MVP development or an enterprise looking to overhaul your digital experience.",
  },
  {
    question: "What tools and technologies do you use?",
    answer:
      "We use modern, scalable tech stacks tailored to your project. This includes React, Next.js, Node.js, Python, Firebase, Shopify, and AWS—avoiding cookie-cutter WordPress templates. We also offer custom CMS and API integrations where required.",
  },
  {
    question: "Can you help us redesign our existing product or website?",
    answer:
      "Absolutely. Whether you're dealing with outdated UI or underperforming functionality, we specialize in turning legacy products into sleek, high-performing digital experiences that reflect your brand and meet current user expectations.",
  },
  {
    question: "Do you provide mobile app development?",
    answer:
      "Yes, we offer both native and cross-platform mobile app development. Our team builds user-centric, fast, and scalable mobile applications that work seamlessly across iOS and Android, integrated with your backend systems.",
  },
  {
    question: "What industries do you specialize in?",
    answer:
      "Our work spans industries like retail, professional services, health, education, fintech, and emerging startups. Our strength lies in applying best-in-class design and technology to solve industry-specific challenges with precision.",
  },
  {
    question: "How long does a typical project take?",
    answer:
      "Timelines vary by project scope, but most websites are delivered within 2–4 weeks. More complex apps or digital platforms may take longer. After our initial discovery call, we’ll provide a detailed timeline tailored to your needs.",
  },
  {
    question: "Do you offer ongoing support or maintenance?",
    answer:
      "Yes, we offer flexible support packages that include bug fixes, security updates, content updates, and performance enhancements. Whether hosted by us or managed on your infrastructure, we ensure your product remains fast, secure, and up-to-date.",
  },
  {
    question: "How do I get started with Digital Thrive?",
    answer:
      "It’s simple. Just reach out via our contact page and we’ll set up a free discovery call. From there, we’ll map out your goals, define the scope, and send over a tailored proposal. No pushy sales—just honest conversations.",
  },
];
